import { reactive, ref } from '@vue/composition-api'

import {
  getProducts as getProductsService
} from '@/app/activations/Services'

export default function Index (props, context) {
  const loadingProducts = ref(null)
  const productOptions = ref([])
  const data = reactive({
    selection: []
  })

  const onProductSearchChange = async (searchQuery) => {
    loadingProducts.value = true
    productOptions.value = await getProductsService(searchQuery)
    loadingProducts.value = false
  }

  const saveValue = (event) => {
    data.selection.push(event)
  }

  const removeOption = (event) => {
    data.selection.filter(x => x.id !== event.id)
  }

  function buildFilters () {
    const productFilters = data.selection.map(x => x.id)
    return { productFilters, data }
  }

  // function setValue () {
  //   const selection = []
  //   const values = props.selectedAsyncProductFilters.product_id
  //   values.forEach(val => {
  //     selection.push(props.asyncProductPool.filter(x => x.id === val)[0])
  //   })
  //   data.selection = []
  //   data.selection = data.selection.concat(selection)
  // }
  //
  // onMounted(() => setValue())

  return { productOptions, onProductSearchChange, saveValue, data, removeOption, buildFilters }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/async_product_multiselect/compositions/Index.js